import { render, staticRenderFns } from "./indicationReport.vue?vue&type=template&id=5670dae2"
import script from "./indicationReport.vue?vue&type=script&lang=js"
export * from "./indicationReport.vue?vue&type=script&lang=js"
import style0 from "./indicationReport.vue?vue&type=style&index=0&id=5670dae2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports